import { useState } from "react";

const faqs = [
  {
    q: "如何按画风筛选 BL 漫画？",
    a: "进入首页的「画风库」，点击上方的画风标签（如水彩晕染、水墨国风、清新淡彩等）即可只显示该画风下的作品；也可以使用关键词搜索或切换排序方式，实时查看筛选结果。",
  },
  {
    q: "什么画风最适合第一次尝试 BL 漫画？",
    a: "新手入门推荐「清新淡彩」与「赛璐璐上色」：线条干净、色彩明快、阅读轻松。等熟悉之后再尝试「水彩晕染」「水墨国风」，更能体会到画风对故事氛围的加成。",
  },
  {
    q: "画风细腻的作品通常有哪些共同特征？",
    a: "常见特征包括：线条笔触精细考究、色彩过渡自然、光影层次丰富、留白与细节处理到位，以及分镜和构图的情绪表达。它们往往在“人物神态”和“氛围营造”上格外用心。",
  },
  {
    q: "「画风推荐」和「画风库」有什么区别？",
    a: "「画风推荐」按画风维度做科普与推荐，帮助你理解每种画风的特征；「画风库」则是可交互的筛选列表，你可以在其中直接按画风筛选、搜索和排序作品。",
  },
  {
    q: "我可以收藏或追更这些作品吗？",
    a: "漫屿当前提供画风筛选与推荐参考。我们持续更新收录的精选作品与画风说明，帮助你发现更多作画精美细腻的 BL 漫画。",
  },
];

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="text-center">
          <p className="text-xs font-medium tracking-widest text-primary-600">常见问题</p>
          <h2 className="mt-2 font-heading text-2xl text-foreground-900 md:text-4xl">关于筛选与推荐，你可能想问</h2>
        </div>

        <div className="mt-10 flex flex-col gap-3">
          {faqs.map((f, i) => {
            const active = open === i;
            return (
              <div key={f.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-100/60">
                <button
                  type="button"
                  onClick={() => setOpen(active ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={active}
                >
                  <span className="text-sm font-medium text-foreground-900 md:text-base">{f.q}</span>
                  <i
                    className={`${active ? "ri-subtract-line text-primary-600" : "ri-add-line text-foreground-500"} text-lg transition`}
                    aria-hidden="true"
                  ></i>
                </button>
                {active && (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}